<template>
  <div>
    <router-view />
    <NavBar v-if="authenticatorEnabled && !$me"
            :menus="menus"
            class="authenticator"
    />
  </div>
</template>

<script>
import NavBar from 'src/components/miscellaneous/ui/navs/NavBar.vue'
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'SduiAuthenticator',
  components: { NavBar },
  mixins: [brandingMixin],
  data: () => ({
    hover: null,
  }),

  computed: {
    authenticatorEnabled() {
      return this.brandingConfig.start.sdui_authenticator || this.$can('totp-2fa', this.$store?.state?.school)
    },

    menus() {
      return [
        {
          key: 'login',
          navigate: { name: 'login-start' },
          icon: 'icon-login',
          title: this.$t('global.footer.login'),
        },
        {
          key: '2fa',
          navigate: { name: 'authenticator-start' },
          icon: 'icon-privacy',
          title: this.$t('global.footer.authenticator'),
        },
      ]
    },
  },
}
</script>
